import moment from "moment";

export const isValidWeekDay = (current: moment.Moment, currentDate?: Date | string, disableWeekends?: boolean): boolean => {
    // Check if current date is a weekend
    const isWeekend = current.day() === 0 || current.day() === 6;

    // If weekends should be disabled and current is a weekend, return false
    if (disableWeekends && isWeekend) {
        return false;
    }

    // If a specific week is provided, restrict to that week
    if (currentDate) {
        const parsedCurrentDate = moment(currentDate, "DD-MM-YYYY");
        const currentWeekStart = parsedCurrentDate.clone().startOf("week");
        const currentWeekEnd = parsedCurrentDate.clone().endOf("week");
        return current.isSameOrAfter(currentWeekStart) && current.isSameOrBefore(currentWeekEnd);
    }

    return true;
};
